import { createReducer } from '@reduxjs/toolkit';
import { logoutSuccess } from 'lib/actions';
import { setJwtHeader } from 'lib/utils';
import { clearRedirectRoute } from 'actions/redirect';

interface RedirectState {
    route: string | null;
    isPosting: boolean;
}

const initialState: RedirectState = {
    route: null,
    isPosting: false,
};

const handleLogoutSuccess = (state: RedirectState) => {
    setJwtHeader(null);
    localStorage.removeItem('accessToken') ??
        localStorage.removeItem('cognitoToken');
    state.route = '/auth';
    state.isPosting = false;
};

const handleClear = (state: RedirectState) => {
    state.route = null;
};

export default createReducer(initialState, builder => {
    builder
        .addCase(logoutSuccess, handleLogoutSuccess)
        .addCase(clearRedirectRoute, handleClear);
});
